// Migrated 1:1 from @nexato/nx-core-module (issue/components/issue-status.component.ts, #688)
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { IssueStatus } from '../../entities/issue/issue-status';

@Component({
    selector: 'app-issue-status',
    template: `
    <div class="px-5 py-3 border-b border-gray bg-white">
        <div class="flex justify-between items-center">
            <div class="flex items-center gap-3 flex-1">
                <div class="flex items-center justify-center">
                    <app-issue-status-icon [issueStatus]="_issueStatus"></app-issue-status-icon>
                </div>
                <div class="flex-1">
                    <div>{{_issueStatus?.label}}</div>
                    <div class="text-sm text-gray-600">{{_issueStatus?.roles?.join(', ')}}</div>
                </div>
            </div>
            <div class="flex-none text-right">
                <nx-default-button
                    [menuItems]="menuItems"
                    [menuWithIcon]="false"
                    class="pt-1"
                    [icon]="'icon-options'">
                </nx-default-button>
            </div>
        </div>
    </div>
    `,
    styles: [`

    `]
})
export class IssueStatusComponent {

    dialogRef: DynamicDialogRef | undefined;

    public menuItems: MenuItem[] = [];
    public _issueStatus: IssueStatus | undefined;

    @Input() set issueStatus(issueStatus: IssueStatus) {
        this._issueStatus = issueStatus;
        //this.setMenuItems();
    }

    @Output() refetch: EventEmitter<any> = new EventEmitter();

    constructor(
        //public dialogService: EditDialogService
    ) {
    }

    // setMenuItems() {
    //     this.menuItems = [];
    //     if (!this._customAttributeSection) {
    //         return;
    //     }
    //     this.menuItems.push({
    //         label: this.translate.instant('coreModuleModule.customAttributeSectionComponent.menu.update'),
    //         disabled: false,
    //         command: () => {
    //             this.updateCustomAttributeSection();
    //         }
    //     });
    //     this.menuItems.push({
    //         label: this.translate.instant('coreModuleModule.customAttributeSectionComponent.menu.delete'),
    //         disabled: !this.isLast(),
    //         command: () => {
    //             this.deleteCustomAttributeSection();
    //         }
    //     });

    //     this.menuItems.push({
    //         label: this.translate.instant('coreModuleModule.customAttributeSectionComponent.menu.moveUp'),
    //         disabled: this.isMoveUpDisabled(),
    //         command: () => {
    //             this.moveUp();
    //         }
    //     });

    //     this.menuItems.push({
    //         label: this.translate.instant('coreModuleModule.customAttributeSectionComponent.menu.moveDown'),
    //         disabled: this.isMoveDownDisabled(),
    //         command: () => {
    //             this.moveDown();
    //         }
    //     });

    //     this.menuItems.push({
    //         label: this.translate.instant('coreModuleModule.customAttributeSectionComponent.menu.createCustomAttributeDefinition'),
    //         disabled: false,
    //         command: () => {
    //             this.createCustomAttributeDefinition();
    //         }
    //     });
    // }

    // isLast(): boolean {
    //     if (!this._customAttributeSection || !this._customAttributeSections) {
    //         return true;
    //     }
    //     return this._customAttributeSection.index === this._customAttributeSections.length - 1;
    // }

    // isMoveUpDisabled(): boolean {
    //     if (!this._customAttributeSection) {
    //         return true;
    //     }
    //     return this._customAttributeSection.index === 0;
    // }

    // // move down is disabled if the current index is the last index in the list
    // isMoveDownDisabled(): boolean {
    //     if (!this._customAttributeSection || !this._customAttributeSections) {
    //         return true;
    //     }
    //     return !(this._customAttributeSection.index < this._customAttributeSections.length - 1);
    // }

    // /**
    //  * moves the current custom attribute section up in the list of custom attribute sections.
    //  * This means: Swap the current section with the section that comes after it in the array.
    //  * @returns
    //  */
    // moveDown(): void {
    //     if (!this._customAttributeSection || !this._customAttributeSections) {
    //         return;
    //     }
    //     const currentIndex = this._customAttributeSection.index;
    //     const nextIndex = currentIndex + 1;
    //     // find the next section
    //     const nextSection = this._customAttributeSections.find(section => section.index === nextIndex);
    //     if (!nextSection) {
    //         return;
    //     }
    //     // we must swap the indices by issuing an update mutation
    //     const currentSectionInput = new CustomAttributeSectionInput();
    //     currentSectionInput.id = this._customAttributeSection.id;
    //     currentSectionInput.label = this._customAttributeSection.label;
    //     currentSectionInput.index = nextIndex;
    //     currentSectionInput.externalId = this._customAttributeSection.externalId;
    //     currentSectionInput.entity = this._customAttributeSection.entity;
    //     const nextSectionInput = new CustomAttributeSectionInput();
    //     nextSectionInput.id = nextSection.id;
    //     nextSectionInput.label = nextSection.label;
    //     nextSectionInput.externalId = nextSection.externalId;
    //     nextSectionInput.index = currentIndex;
    //     nextSectionInput.entity = nextSection.entity;
    //     this.loadingService.setLoading(true);
    //     this.customAttributesService.update(currentSectionInput, () => {
    //         this.customAttributesService.update(nextSectionInput, () => {
    //             this.refetch.emit();
    //             this.loadingService.setLoading(false);
    //             this.toastService.addToastWithMessage('coreModuleModule.customAttributeSectionComponent.customAttributeSectionMovedDownToastMessage');
    //         });
    //     });
    // }

    // /**
    //  * moves the current custom attribute section up in the list of custom attribute sections.
    //  * This means: Swap the current section with the section that comes before it in the array.
    //  * @returns
    //  */
    // moveUp(): void {
    //     if (!this._customAttributeSection || !this._customAttributeSections) {
    //         return;
    //     }
    //     const currentIndex = this._customAttributeSection.index;
    //     const previousIndex = currentIndex - 1;
    //     // find the previous section
    //     const previousSection = this._customAttributeSections.find(section => section.index === previousIndex);
    //     if (!previousSection) {
    //         return;
    //     }
    //     // we must swap the indices by issuing an update mutation
    //     const currentSectionInput = new CustomAttributeSectionInput();
    //     currentSectionInput.id = this._customAttributeSection.id;
    //     currentSectionInput.label = this._customAttributeSection.label;
    //     currentSectionInput.externalId = this._customAttributeSection.externalId;
    //     currentSectionInput.index = previousIndex;
    //     currentSectionInput.entity = this._customAttributeSection.entity;
    //     const previousSectionInput = new CustomAttributeSectionInput();
    //     previousSectionInput.id = previousSection.id;
    //     previousSectionInput.label = previousSection.label;
    //     previousSectionInput.externalId = previousSection.externalId;
    //     previousSectionInput.index = currentIndex;
    //     previousSectionInput.entity = previousSection.entity;
    //     this.loadingService.setLoading(true);
    //     this.customAttributesService.update(currentSectionInput, () => {
    //         this.customAttributesService.update(previousSectionInput, () => {
    //             this.refetch.emit();
    //             this.loadingService.setLoading(false);
    //             this.toastService.addToastWithMessage('coreModuleModule.customAttributeSectionComponent.customAttributeSectionMovedUpToastMessage');
    //         });
    //     });
    // }

    // deleteCustomAttributeSection(): void {
    //     this.dialogRef = this.confirmDialogService.open({
    //         message: this.translate.instant(
    //         'coreModuleModule.customAttributeSectionComponent.deleteCustomAttributeSectionDialogMessage',
    //         { customAttributeSectionId: this._customAttributeSection?.id }
    //         ),
    //         severity: ConfirmDialogSeverity.WARN,
    //         header: 'coreModuleModule.customAttributeSectionComponent.deleteCustomAttributeSectionDialogHeader',
    //     });
    //     this.dialogRef.onClose.subscribe((result: ConfirmDialogEventType) => {
    //         if (result === ConfirmDialogEventType.CONFIRM) {
    //         this.loadingService.setLoading(true);
    //         this.customAttributesService.delete(this._customAttributeSection?.id, () => {
    //             this.refetch.emit();
    //             this.toastService.addToastWithMessage('coreModuleModule.customAttributeSectionComponent.customAttributeSectionDeletedToastMessage');
    //         });
    //         };
    //     })
    // }

    // updateCustomAttributeSection(): void {
    //     this.dialogRef = this.dialogService.open(CustomAttributeSectionDialogComponent, {
    //         header: 'coreModuleModule.customAttributeSectionComponent.updateCustomAttributeSectionDialogHeader',
    //         data: {
    //             customAttributeSection: this._customAttributeSection
    //         }
    //     });
    //     this.dialogRef.onClose.subscribe((result) => {
    //         // result is true or false, indiciating if it should refetch
    //         if (result) {
    //             this.refetch.emit();
    //             this.toastService.addToastWithMessage('coreModuleModule.customAttributeSectionComponent.customAttributeSectionUpdatedToastMessage');
    //         }
    //     });
    // }

    // createCustomAttributeDefinition(): void {
    //     this.dialogRef = this.dialogService.open(CustomAttributeDefinitionDialogComponent, {
    //         header: 'coreModuleModule.customAttributeSectionComponent.createCustomAttributeDefinitionDialogHeader',
    //         data: {
    //             customAttributeSectionId: this._customAttributeSection?.id,
    //             nextIndex: this._customAttributeSection?.customAttributeDefinitions?.length || 0,
    //             entityType: this._customAttributeSection?.entity,
    //         }
    //     });
    //     this.dialogRef.onClose.subscribe((result) => {
    //         // result is true or false, indiciating if it should refetch
    //         if (result) {
    //             this.refetch.emit();
    //             this.toastService.addToastWithMessage('coreModuleModule.customAttributeSectionComponent.customAttributeDefinitionCreatedToastMessage');
    //         }
    //     });
    // }

}
